import { InformationState, INFORMATION_STORE as s } from './types';
import { MutationTree } from 'vuex';
import { Individu } from '@/models/Individu';
import { Parent } from '@/models/Parent';
import { MedecinDocument } from '@/models/MedecinDocument';
import { MaladieDocument } from '@/models/MaladieDocument';
import { Autorisations } from '@/models/Autorisations';
import { AllergieDocument } from '@/models/AllergieDocument';
import { VaccinDocument } from '@/models/VaccinDocument';
import { ChampLibreResultDocument } from '@/models/ChampLibreResultDocument';
import { ChampLibreDocument } from '@/models/ChampLibreDocument';
import { ChampLibreValeurDocument } from '@/models/ChampLibreValeurDocument';
import { ChampLibreResultValeurDocument } from '@/models/ChampLibreResultValeurDocument';
import { InformationIndividuDocument } from '@/models/InformationIndividuDocument';
import { DossierDocument } from '@/models/DossierDocument';

export const mutations: MutationTree<InformationState> = {
    [s.SET_PARENTS](state, parents: Parent[]) {
        state.parents = parents;
    },

    [s.SET_INDIVIDU](state, individu: Individu) {
        state.individu = individu;
    },

    [s.SET_MEDECIN](state, medecin: MedecinDocument) {
        state.medecin = medecin;
    },

    [s.SET_MALADIES](state, maladies: MaladieDocument[]) {
        state.maladies = maladies;
    },
    [s.SET_AUTORISATIONS](state, autorisations: Autorisations[]) {
        state.autorisations = autorisations;
    },
    
    [s.SET_ALLERGIES](state, allergies: AllergieDocument[]) {
        state.allergies = allergies;
    },

    [s.SET_VACCINS](state, vaccins: VaccinDocument[]) {
        state.vaccins = vaccins;
    },

    [s.SET_FAMILLE_CHAMPS](state, famille_champs: ChampLibreResultDocument[]) {
        state.famille_champs = famille_champs;
    },

    [s.SET_INDIVIDU_CHAMPS](state, individu_champs: ChampLibreResultDocument[]) {
        state.individu_champs = individu_champs;
    },

    [s.SET_CHAMPS_LIBRES](state, champs_libres: ChampLibreDocument[]) {
        state.champs_libres = champs_libres;
    },

    [s.SET_CHAMPS_LIBRES_VALEURS](state, champs_libres_valeurs: ChampLibreValeurDocument[]) {
        state.champs_libres_valeurs = champs_libres_valeurs;
    },

    [s.SET_CHAMPS_LIBRES_RESULTS_VALEURS](state, Champs_libres_results_valeurs: ChampLibreResultValeurDocument[]) {
        state.Champs_libres_results_valeurs = Champs_libres_results_valeurs;
    },

    [s.SET_INFORMATION_INDIVIDU](state, information_individu: InformationIndividuDocument[]) {
        state.information_individu = information_individu;
    },

    [s.SET_DOSSIER](state, dossier: DossierDocument) {
        state.dossier = dossier;
    },
}